import * as React from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import OfferGoogleBreadcrumbsStructuredData from './OfferGoogleBreadcrumbsStructuredData'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import { useLocalizedBreadcrumbs } from 'hooks/usePlace'
import TextLink from 'LuxKit/TextLink'

const RelatedItemsGrid = styled(LayoutContainer)`
  margin-top: ${rem(32)};
  padding-bottom: ${rem(32)};

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

const MobileRelatedItems = styled.ul`
  list-style-type: none;
  margin-block: ${rem(8)} 0;
  margin-inline: 0;

  > li + li {
    margin-top: ${rem(8)};
  }
`

interface Props {
  offer: App.Offer | App.BedbankOffer
  title?: string
  regionCode: string
  items: Array<App.BreadcrumbItem>
  selfLinkItem?: React.ReactNode
}

function BottomMobileRelatedTravelItems({ offer, title, regionCode, items, selfLinkItem }: Props) {
  const intl = useIntl()
  const localizedItems = useLocalizedBreadcrumbs(items)

  return <>
    <OfferGoogleBreadcrumbsStructuredData
      market={regionCode}
      offer={offer}
      relatedTravelItems={localizedItems}
    />
    <RelatedItemsGrid>
      <BodyText weight="bold" variant="large">{title || intl.formatMessage({
        id: 'aMuZ47u-SeUrl1ghgaOR',
        defaultMessage: 'Related Travel',
        description: 'Default heading for related travel items section on offer page',
      })}
      </BodyText>
      <MobileRelatedItems>
        {selfLinkItem && <li>{selfLinkItem}</li>}
        {localizedItems.map((item, index) => <li key={index}>
          {item.url && <TextLink title={item.text} weight="regular" size="caption" to={item.url}>{item.text}</TextLink>}
          {!item.url && <Caption variant="medium">{item.text}</Caption>}
        </li>)}
      </MobileRelatedItems>
    </RelatedItemsGrid>
  </>
}

function mapStateToProps(state: App.State) {
  return {
    regionCode: state.geo.currentRegionCode,
  }
}

export default connect(mapStateToProps)(BottomMobileRelatedTravelItems)
